const initElementTimestamp = id => ({
  id,
  timestamp: Date.now()
});

export { initElementTimestamp };
